import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "phone-completion-dialog__list-wrapper" }
const _hoisted_2 = { class: "phone-completion-dialog__list-item" }
const _hoisted_3 = { class: "phone-completion-dialog__list-wrapper" }
const _hoisted_4 = { class: "phone-completion-dialog__list-item" }
const _hoisted_5 = { class: "phone-completion-dialog__info-text" }

import {computed, ref, watch} from 'vue';
    import PhoneNumber from './PhoneNumber.vue';
    import {pushVJoySnackbar, VJoyDialog} from '@maltjoy/core-vue';
    import {useVuelidate} from '@vuelidate/core';
    import {useTranslation} from '@malt/vue3-use';
    import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
    import {PhoneRequest} from '@/common/api/api-raw-types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumberCompletionDialog',
  props: ['open', 'forceModal', 'isSkippable'],
  emits: ["cancel", "confirm"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const dialogRef = ref<InstanceType<typeof VJoyDialog>>();

    watch(
        () => props.open,
        async (value) => {
            if (value) {
                await dialogRef.value?.show();
            }
        },
    );

    const {msg} = useTranslation();
    const phoneNumberModel = ref<string>('');
    const cancelLabel = computed<string | undefined>(() => {
        return props.isSkippable
            ? msg('phone.number.completion.dialog.skip')
            : props.forceModal
            ? undefined
            : msg('phone.number.completion.dialog.do.not.contact.freelancer');
    });

    const v$ = useVuelidate();

    async function validatePhoneNumber() {
        await v$.value.$validate();
        if (v$.value.$invalid) {
            return;
        }

        const [, error] = await context.httpService.post(context.registry.entries.updatePhone(), {number: phoneNumberModel.value} as PhoneRequest);

        if (error) {
            pushVJoySnackbar({props: {message: msg('customer.brief.error.unknown'), level: 'error'}});
            return;
        }

        emits('confirm');
    }

    function onDialogClose() {
        emits('cancel');
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createBlock(_unref(VJoyDialog), {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "phone-completion-dialog",
    "data-testid": "phone-number-completion-dialog",
    "pattern-confirm": __props.forceModal,
    open: __props.open,
    "cancel-text": cancelLabel.value,
    "confirm-text": _unref(msg)('phone.number.completion.dialog.confirm'),
    "onDialog:hide": onDialogClose,
    "onDialog:confirm": validatePhoneNumber
  }, {
    "dialog-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(msg)('phone.number.completion.dialog.title')), 1)
    ]),
    "dialog-body": _withCtx(() => [
      _createVNode(_component_VJoyWrapper, { class: "phone-completion-dialog__body" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_unref(msg)('phone.number.completion.dialog.enter.phone.number.prompt')), 1),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_VJoyIcon, { name: "check-circle" }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(msg)('phone.number.completion.dialog.strengthen.security')), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_VJoyIcon, { name: "check-circle" }),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(msg)('phone.number.completion.dialog.benefit.from.support')), 1)
            ]),
            _createVNode(PhoneNumber, {
              modelValue: phoneNumberModel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumberModel).value = $event)),
              required: true,
              "lazy-validation": true,
              "data-testid": "phone-number-completion-dialog-input-phone",
              class: "phone-completion-dialog__number"
            }, null, 8, ["modelValue"]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(msg)('phone.number.completion.dialog.phone.number.visibility')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["pattern-confirm", "open", "cancel-text", "confirm-text"]))
}
}

})